import { ButtonDefault } from "../buttons/ButtonDefault";
import styles from "./DialogSelect.module.scss";

function DialogSelect({
  textHeader = "Header",
  textBody = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  actions = [
    { text: "action A", handler: () => console.log("A") },
    { text: "action B", handler: () => console.log("B") },
  ],
  cancel = () => console.log("cancel"),
}) {
  return (
    <div
      className={styles["background"]}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          cancel();
        }
      }}>
      <div className={styles["foreground"]}>
        <div className={styles["foreground-header"]}>
          <div className={styles["foreground-header-text"]}>{textHeader}</div>
        </div>
        <div className={styles["foreground-body"]}>{textBody}</div>
        <div className={styles["foreground-footer"]}>
          {actions.map((e, index) => (
            <ButtonDefault key={index} text={e.text} handler={e.handler} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default DialogSelect;
